export default (function (siteVars) {
  return {
    borderColorHover: siteVars.accessibleYellow,
    disabledToggleIndicatorColor: siteVars.accessibleGreen
  };
});